// Angular modules
import { AfterViewInit, Component, ElementRef, ViewChild }          from '@angular/core';

// Ionic modules
import { GoogleAnalytics }    from '@ionic-native/google-analytics';
import { NavController }      from 'ionic-angular';
import { Platform }           from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { ToastController }    from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';

// External modules
import { ApplicationService } from '../../shared/providers/application-service';
import { AuthService }        from '../../shared/providers/auth-service';
import { CreateAccountPage }  from '../create-account/create-account';
import { HomeMenuPage }       from '../home-menu/home-menu';
import { LegalTermsPage }     from '../legal-terms/legal-terms';
import { TranslateService }   from '@ngx-translate/core';

// Internal modules
import { environment }        from '../../../environments/environment';

// Helpers
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector    : 'page-home',
  templateUrl : 'home.html',
  providers   : [ AuthService, ApplicationService]
})

export class HomePage implements AfterViewInit
{
  l            : any;
  p            : any;
  waitingLabel : string  = "Please wait...";
  auth2        : any;
  google       : any;

  @ViewChild('buttonGoogleLogin') googleButton: ElementRef = new ElementRef({});

  constructor(public  navCtrl            : NavController,
              public  toastCtrl          : ToastController,
              public  menuCtrl           : MenuController,
              public  authService        : AuthService,
              public  platform           : Platform,
              public  loadingCtrl        : LoadingController,
              public  translate          : TranslateService,
              public  applicationService : ApplicationService,
              private analytics          : GoogleAnalytics)
  {}

  ngAfterViewInit(): void
  {
    let google = window['google'];
    this.google = google;

    if(this.google == undefined)
    {
      console.log('Google library not loaded');
      return;
    }

    console.log('Google library loaded');

    google.accounts.id.initialize({
      client_id            : environment.GOOGLE_AUTH_ID,
      callback             : this.googleLogin.bind(this),
      auto_select          : false,
      cancel_on_tap_outside: false
    });

    google.accounts.id.renderButton(
      this.googleButton.nativeElement ,
      {
        theme         : 'outline',
        size          : 'large',
        shape         : 'rectangular',
        width         : '250',
        text          : 'signin_with',
        logo_alignment: 'center'
      }
    );
  }

  public stdLogin() : void
  {
    this.authService.stdServerAuth(this.l, this.p).subscribe(user =>
    {
      this.setConnectedUser(user, null);
    },
    err =>
    {
      this.presentToast(err);
    });
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Login ");
  }

  initTranslations()
  {
    this.translate.instant('PLEASE_WAIT');
  }

  goToHomeMenu()
  {
    this.navCtrl.push(HomeMenuPage,{}, {animate: false});
  }

  goToSynchronize()
  {
    this.navCtrl.push(SynchronizePage,{}, {animate: false});
  }

  goToLegalTerms()
  {
    this.navCtrl.push(LegalTermsPage,{}, {animate: false});
  }

  presentToast(message)
  {
     let toast = this.toastCtrl.create({
       message: message,
       duration: 3000
     });
     toast.present();
  }

  presentLoading()
  {
    let loader = this.loadingCtrl.create({
      content: this.waitingLabel
    });
    return loader;
  }

  createAccount()
  {
    this.navCtrl.push(CreateAccountPage,{}, {animate: false});
  }

  googleLogin(response : any)
  {
    if(response == null)
      return;

    let loader  = this.presentLoading();
    loader.present();

    this.checkLogin(response.credential);
    loader.dismiss();
  }

  setLogin(event : any)
  {
    this.l = event.currentTarget.value;

  }

  setPwd(event : any)
  {
    this.p = event.currentTarget.value;
  }

  checkLogin(serverAuthCode : string)
  {
    this.authService.googleServerAuth(serverAuthCode)
    .subscribe(user =>
    {
      this.setConnectedUser(user, serverAuthCode);
    },
    _ =>
    {
      this.presentToast("Error : Maybe your account is not created or activated. Please contact your administrator.");
    });
  }

  setConnectedUser(user: any, googleToken: string)
  {
    StorageHelper.setUser({
      name            : user.UserName,
      email           : user.Email,
      userId          : user.UserId,
      token           : googleToken,
      CanSeeCompetitor: user.CanSeeCompetitor
    });

    if(StorageHelper.getDocument() == null)
    {
      this.goToSynchronize();
      return;
    }

    this.presentToast('Welcome to MAP App ' + user.Email);
    this.goToHomeMenu();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.ts